<template>
  <router-link class="c-button" :class="{ 'c-button--disabled': disabled, 'c-button--subtle': subtle }" :to="to" event="" @click.native.prevent="emitClick">
    <svg class="c-button__arrow c-button__arrow--left" width="16" height="16" viewBox="0 0 16 16" v-if="arrowLeft">
      <path :fill="arrowColor !== null ? arrowColor : '#E82E24'" d="M12 3v10L4 8z"/>
    </svg>
    <slot/>
    <svg class="c-button__arrow c-button__arrow--right" width="16" height="16" viewBox="0 0 16 16" v-if="arrow && !arrowLeft">
      <path :fill="arrowColor !== null ? arrowColor : '#E82E24'" d="M4 3v10l8-5z"/>
    </svg>
  </router-link>
</template>

<script>
export default {
	//attributes of the tag navigate-button
  props: {
    to: {
      default: '#'
    },
    arrow: {
      default: true
    },
    arrowLeft: {
      default: false
    },
    arrowColor: {
      default: null
    },
    disabled: {
      default: false
    },
    subtle: {
      default: false
    }
  },
  methods: {
		//special event handling
    emitClick () {
      if (!this.disabled) {
        this.$emit('click')
        if (this.to !== '#') {
          this.$router.push(this.to)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.c-button,
a.c-button {
  align-items: center;
  border: 1px solid rgba(#FFF, 0.5);
  color: #FFF;
  display: inline-flex;
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
  padding: 1.1rem 1.6rem;
  text-transform: uppercase;
  transition: all 0.15s linear;

  &:not(.c-button--disabled):hover {
    background-color: rgba(#FFF, 0.1);
    border-color: #FFF;
  }

  &.c-button--disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.c-button--subtle,
a.c-button--subtle {
  border: 0;
  opacity: 0.5;
  padding: 0;

  svg * {
    fill: #FFF;
  }

  &:not(.c-button--disabled):hover {
    background: none;
    opacity: 1;
  }
}

.c-button__arrow {
  display: block;
  flex: none;
}

.c-button__arrow--left {
  margin-right: 1.6rem;
}

.c-button__arrow--right {
  margin-left: 1.6rem;
}
</style>
